import React, { Suspense } from "react";
import { hydrate, render } from "react-dom";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import { Provider } from "mobx-react";
import { I18nextProvider } from "react-i18next";

import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "app/components/app/App";
import { RootStore } from "app/stores";
import i18n from "i18n";
import theme from "theme";

import * as serviceWorker from "./serviceWorker";

const history = createBrowserHistory();

const app = (
  <Provider {...RootStore}>
    <Suspense fallback=" ">
      <I18nextProvider i18n={i18n}>
        <Router history={history}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </MuiThemeProvider>
        </Router>
      </I18nextProvider>
    </Suspense>
  </Provider>
);

const rootElement = document.getElementById("root");
if (rootElement && rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
